import ProfileModel from "../../Profile/Models/ProfileModel";
import PrivateLeagueBasicModel from "./PrivateLeagueModel";

export default class AcceptPrivateLeagueModel {
  public profileId: string = "";
  public profileModel: ProfileModel = null;
  public leagueId: string = "";
  public leagueModel: PrivateLeagueBasicModel = null;
  public message: string = "";
}
